<footer class="black_bg white">
  <div class="container">
    <!-- <p>© {{year}}  All Rights Reserved | Stamford Tyres Africa (Pty) LTD | Privacy Policy</p> -->
    <p>© {{year}}  All Rights Reserved | Stamford Tyres Africa (Pty) LTD</p>
  </div>
</footer>